import keycloak from '@app/../keycloak';


const getFreshAccessToken = function() {
  if (keycloak.isTokenExpired(10)) {
    keycloak.updateToken(10);
  }
  return keycloak.token;
};

export default getFreshAccessToken;
